// import { LoadingOverlay } from '@mantine/core';
// import { useState } from 'react';
// import { useTranslation } from 'react-i18next';

const TeamPage = () => {
  // const [loading, setLoading] = useState(false);

  return (
    <div style={{ position: 'relative', minHeight: '80vh' }}>
      {/* <LoadingOverlay visible={loading} /> */}
      TeamPage
    </div>
  );
};

export default TeamPage;
